
import { Vue, Component, Prop, Watch } from "vue-property-decorator";

@Component
export default class vModal extends Vue {
  @Prop() show!: boolean;
  @Prop() modalTitle!: string;
  @Prop() size?: string;
  @Prop() modalId?: string;

  @Watch("show")
  showModal() {
    let bodee = document.getElementsByTagName("body")[0];
    if (this.show) bodee.classList.add("modalOpen");
    else bodee.classList.remove("modalOpen");
  }

  hideModal() {
    this.$emit("hideModal");
  }

  cancelModal() {
    this.$emit("cancelModal");
  }

  mounted() {
    document.addEventListener("keydown", (e) => {
      if (this.show && e.keyCode == 27) {
        this.cancelModal();
      }
    });
  }
}
